var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"station"},[_c('i',{staticClass:"fas fa-angle-right"}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.item.displayName))])])}
var staticRenderFns = []

export { render, staticRenderFns }